// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".outer-box[data-v-a6b05738]{padding-bottom:90px}.outer-box .mt-144[data-v-a6b05738]{margin-top:55px}@media (max-width:1365px){.outer-box[data-v-a6b05738]{padding-bottom:60px}}@media (max-width:767px){.outer-box[data-v-a6b05738]{padding-bottom:30px}}", ""]);
// Exports
module.exports = exports;
